import { MAX_DECIMAL_POSITIONS } from '../api/constants';

export const toDecimal = (cents: number): number => {
  return cents / 100;
};

export const toCents = (decimal: number): number => {
  return decimal * 100;
};

export const roundPrice = (cents: number): number => {
  const decimal = toDecimal(cents);
  // Math.round() rounds e.g. -1.5 to -1 instead of -2
  // so the code below is to ensure it's always rounded to -2
  const round = Math.round(Math.abs(decimal));
  return cents < 0 ? -1 * toCents(round) : toCents(round);
};

export const formatClientPrice = (
  languageTag: string,
  cents: number,
  currencySymbol: string
): string => {
  if (cents === undefined) {
    return '-';
  }

  const parsedValue = toDecimal(cents).toFixed(MAX_DECIMAL_POSITIONS);

  const formatter = new Intl.NumberFormat(languageTag, {
    style: 'decimal',
    minimumFractionDigits: 2,
  });

  const formattedPrice = formatter.format(Number(parsedValue));

  return `${formattedPrice} ${currencySymbol}`;
};
